import {Component, Input} from "@angular/core";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {VideoDialogComponent} from "../dialogs/video-dialog/video-dialog.component";

@Component({
    selector: 'db-how-to-videos',
    templateUrl: './how-to-videos.component.html',
    styleUrls: ['./how-to-videos.component.scss'],
    standalone: false
})
export class HowToVideosComponent {

  @Input() url: string;
  @Input() title: string;
  @Input() desc: string;
  @Input() descSecond?: string;
  @Input() titleSecond?: string;

  constructor(
    private _dialogService: DialogService
  ) {}



  public openVideo(): void {
    this._dialogService
      .addDialog(VideoDialogComponent, {
        url: this.url,
      })
      .subscribe((confirmed: boolean): void => {

      });
  }

}
